//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GetOrderLogList } from '@/api/yytapi';
export default {
  name: 'OrderLog',
  data: function data() {
    return {
      tableData: {},
      tableFrom: {
        page: 1,
        limit: 20,
        operatorName: '',
        operatorType: '',
        orderSn: ''
      },
      listLoading: false
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      var params = {
        page: this.tableFrom.page,
        limit: this.tableFrom.limit
      };
      if (this.tableFrom.operatorName) params.operatorName = this.tableFrom.operatorName;
      if (this.tableFrom.operatorType !== '' && this.tableFrom.operatorType !== null) params.operatorType = this.tableFrom.operatorType;
      if (this.tableFrom.orderSn) params.orderSn = this.tableFrom.orderSn;
      GetOrderLogList(params).then(function (res) {
        _this.tableData = res || {
          list: [],
          total: 0
        };
      }).finally(function () {
        _this.listLoading = false;
      });
    },
    onSearch: function onSearch() {
      this.tableFrom.page = 1;
      this.getList();
    },
    onReset: function onReset() {
      this.tableFrom = {
        page: 1,
        limit: 20,
        operatorName: '',
        operatorType: '',
        orderSn: ''
      };
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.tableFrom.page = 1;
      this.getList();
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    operatorTypeText: function operatorTypeText(type) {
      var map = {
        0: '系统',
        1: '用户',
        2: '管理员'
      };
      return map[type] || '-';
    },
    operatorTypeTag: function operatorTypeTag(type) {
      var map = {
        0: 'info',
        1: '',
        2: 'warning'
      };
      return map[type] || 'info';
    }
  }
};